import filesActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';

export const reducers = {
  query: createAsyncRequestReducer(filesActionTypes.FETCH_FILES),
  fetch: createAsyncRequestReducer(filesActionTypes.FETCH_PROJECT_FILES),
  create: createAsyncRequestReducer(filesActionTypes.CREATE_FILE),
  delete: createAsyncRequestReducer(filesActionTypes.DELETE_FILE),
  upload: createAsyncRequestReducer(filesActionTypes.UPLOAD_FILE),
  getDownloadUrl: createAsyncRequestReducer(
    filesActionTypes.FETCH_FILE_DOWNLOAD_URL,
  ),
  getFile: createAsyncRequestReducer(filesActionTypes.GET_FILE),
  rename: createAsyncRequestReducer(filesActionTypes.RENAME_FILE),
  activeFilesPath: createReducer(
    { activePath: '' },
    {
      [filesActionTypes.SET_ACTIVE_FILES_PATH]: (state: any, action: any) => {
        return {
          ...state,
          activePath: action.activePath,
        };
      },
    },
  ),
};

export default combineReducers(reducers);
